export default __webpack_public_path__ + "static/media/logo4.d0ac46d3.png";